import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {styled} from "@mui/material/styles";

import ListingCheckbox, {ListingCheckboxPlaceholder} from "components/Product/Table/ListingCheckbox";
import {grey25, greyishBlue100, greyishBlue600} from "assets/jss/main";

const FILL_MIN_WIDTH = '186px';

export const COLUMN_WIDTHS = {
    product: '302px',
    scoring: '104px',
    variants: '192px',
    suggestion: null,
    attributes: null,
    action: '176px',
    pictures: null,
};

export const Table = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 'normal',
    border: `1px solid ${greyishBlue100}`,
    borderRadius: '8px',
    overflowX: 'auto',
});

const HeaderRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '32px',
    padding: '8px 16px',
    minHeight: '48px',
    boxSizing: 'border-box',
    minWidth: 'min-content',
    backgroundColor: grey25,
    borderBottom: `1px solid ${greyishBlue100}`,
    borderRadius: '8px 8px 0 0',
});

export const Row = styled('div')({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '32px',
    padding: '16px',
    minWidth: 'min-content',
    backgroundColor: '#fff',
    borderBottom: `1px solid ${greyishBlue100}`,
    '&:last-of-type': {
        borderBottom: 'none',
        borderRadius: '0 0 8px 8px',
    },
});

export const Cell = styled('div', {shouldForwardProp: (prop) => 'column' !== prop})(({column}) => {
    const width = COLUMN_WIDTHS[column];

    return width
        ? {width, flexShrink: 0, minWidth: 0}
        : {flex: '1 0 0', minWidth: FILL_MIN_WIDTH};
});

const Label = styled('span')({
    color: greyishBlue600,
    fontSize: '14px',
    fontWeight: 400,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
});

const ProductLabel = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
});

TableHeader.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.string).isRequired,
    selectable: PropTypes.bool,
    allSelected: PropTypes.bool,
    onSelectAll: PropTypes.func,
};

export function TableHeader({columns, selectable = false, allSelected = false, onSelectAll}) {
    return (
        <HeaderRow>
            {columns.map((column) => (
                <Cell key={column} column={column}>
                    {'product' === column ? (
                        <ProductLabel>
                            {selectable
                                ? <ListingCheckbox checked={allSelected} onChange={onSelectAll}/>
                                : <ListingCheckboxPlaceholder/>}
                            <Label><FormattedMessage id={`enrichment.column.${column}`}/></Label>
                        </ProductLabel>
                    ) : (
                        <Label><FormattedMessage id={`enrichment.column.${column}`}/></Label>
                    )}
                </Cell>
            ))}
        </HeaderRow>
    );
}
